import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
//   CardContent,
  CardMedia,
} from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image2 from "../../images/pos1.jpg";
import image3 from "../../images/pos2.jpeg";
import image4 from "../../images/pos3.jpg";
import image5 from "../../images/pos4.jpg";
import image6 from "../../images/pos5.jpg";
import image7 from "../../images/pos6.jpg";
import pose1 from "../../images/yoga1.jpeg";
import pose2 from "../../images/yoga2.jpeg";
import pose3 from "../../images/yoga3.jpeg";
import pose4 from "../../images/yoga4.jpeg";
import pose5 from "../../images/yoga5.jpeg";
import pose6 from "../../images/yoga6.jpeg";

const Classes = () => {
  const cardsData = [
    {
      title: "Hatha Yoga",
      image: pose1,
    },
    {
      title: "Vinyasa Yoga",
      image: pose2,
    },
    {
      title: "Kundalini Yoga",
      image: pose3,
    },
    {
      title: "Intuitive Yoga",
      image: pose4,
    },
    {
      title: "Aroma Yoga",
      image: pose5,
    },
    {
      title: "Slow Yoga",
      image: pose6,
    },
  ];

  const carouselData = [
    {
      title: "Morning Yoga",
      image: image5,
    },
    {
      title: "Evening Yoga",
      image: image2,
    },
    {
      title: "Advanced Yoga",
      image: image3,
    },
    {
      title: "Family Yoga",
      image: image4,
    },
    {
      title: "Family Yoga",
      image: image6,
    },
    {
      title: "Family Yoga",
      image: image7,
    },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <>
      <Box sx={{ padding: "40px" }}>
        {/* Header Section */}
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          Classes
        </Typography>
        <Typography
          variant="h4"
          sx={{ marginTop: "20px", textAlign: "center", fontWeight: "bold" }}
        >
          Dive into the World of Health & Fitness
        </Typography>
  

        {/* Cards Section */}
        <Grid container spacing={3} sx={{ marginTop: "50px" }}>
          {carouselData.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ height: "100%", boxShadow: 3,}}>
                <CardMedia
                  component="img"
                  height="270"
                  sx={{ objectFit: "contain" }}
                  image={card.image}
                  alt={card.title}
                />
                {/* <CardContent>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    {card.title}
                  </Typography>
                </CardContent> */}
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Carousel Section */}
        <Box
          sx={{
            marginTop: "60px",
            maxWidth: "800px",
            marginX: "auto",
            padding: "20px",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              marginBottom: "20px",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            Explore More Yoga Programs
          </Typography>
          <Slider {...sliderSettings}>
            {cardsData.map((slide, index) => (
              <Box key={index} sx={{ padding: "0 10px" }}>
                <Card sx={{ boxShadow: 3 }}>
                  <CardMedia
                    component="img"
                    height="500"
                    image={slide.image}
                    alt={slide.title}
                  />
                </Card>
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>
    </>
  );
};

export default Classes;
